import script from "./MessageList.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageList.vue?vue&type=script&setup=true&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=36e96046&lang=scss"

const __exports__ = script;

export default __exports__